//Third party libraries

import { useParams } from 'react-router';
//Services
import { useApplicationTeamMembers } from '@/hooks/ReactQueryHooks/useApplicationQuery';
//Custom components
import RoverTeamCard from './RoverTeamCard';

//Assets and miscellaneous

function RoverTeam() {
  const { applicationId } = useParams();
  const fetchApplicationTeamMembers = useApplicationTeamMembers({
    applicationId: applicationId,
  });
  const applicationTeamMembers = fetchApplicationTeamMembers?.data?.data;

  return (
    <>
      {fetchApplicationTeamMembers.isSuccess && (
        <div className='grid lg:grid-cols-2 gap-8 my-5'>
          <RoverTeamCard team='Team Members' teams={applicationTeamMembers} />
        </div>
      )}
    </>
  );
}
export default RoverTeam;
